import React from 'react'
import { LuMenu, LuWallet } from 'react-icons/lu'
import { isEqual } from '../contexts/Utils'
import { useLocation, useNavigate } from 'react-router-dom';
import { PiMoneyWavyLight, PiPlugCharging } from 'react-icons/pi';
import { AiOutlineHome } from 'react-icons/ai';

type Props = {
  openMenu?: () => void
}
function MenuBar({ openMenu }: Props) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const menu = [
    {
      key: '/billings',
      label: 'Billings',
      Icon: ({ className }: { className?: string }) => <PiMoneyWavyLight className={"!text-lg ".concat(className!)} />,
    },
    {
      key: '/vending',
      label: 'Vending',
      Icon: ({ className }: { className?: string }) => <PiPlugCharging className={"!text-lg ".concat(className!)} />,
    },
    {
      label: 'Home',
      key: '/dashboard',
      className: "!pt-5",
      Icon: ({ isActive }: { isActive?: boolean }) => <AiOutlineHome className={`!text-3xl text-white p-1.5 rounded-full absolute -top-5 ${isActive ? "bg-primary" : "bg-silver"}`} />,
    },
    {
      key: '/wallet',
      label: 'Wallet',
      Icon: ({ className }: { className?: string }) => <LuWallet className={"!text-lg ".concat(className!)} />,
    },
    {
      key: 'menu',
      label: 'Menu',
      onclick: openMenu,
      Icon: ({ className }: { className?: string }) => <LuMenu className={"!text-lg ".concat(className!)} />,
    },
  ]
  return (
    <div className='w-full md:hidden border-t border-outline fixed bottom-0 p-1 pb-3 bg-white z-10'>
      <div className='w-full grid grid-cols-5 relative'>
        {menu.map(({Icon, key, label, className, onclick}) => {
          const isActive = isEqual(key, pathname)
          const handleNavigate = () => (onclick ? onclick() : navigate(key))
          return (
          <div key={key} onClick={handleNavigate} className='w-full flex flex-col justify-center items-center gap-1'>
            <Icon isActive={isActive} className={isActive ? "!text-primary" : "!text-silver"} />
            <p className={`text-sm font-normal ${isActive ? "text-primary" : "text-silver"} ${className}`}>{label}</p>
          </div>
        )})}
      </div>
    </div>
  )
}

export default MenuBar